import { CustomerInviteHook } from '@services';
import { useStore } from '@stores';
import dayjs from 'dayjs';
import { useEffect } from 'react';

export const useCustomerSmsInvite = (customerId: string | undefined): CustomerInviteHook => {
  const { customerStore } = useStore();
  const { customerSmsInvite, customerSmsInviteLoading } = customerStore;

  useEffect(() => {
    customerId &&
      customerStore.getSmsInvite({
        customerId,
        type: 'SmsInvite',
        creationDate: dayjs().format(),
      });

    return () => {
      customerStore.clearCustomerSmsInvite();
    };
  }, [customerStore, customerId]);

  return { customerInvite: customerSmsInvite, loading: customerSmsInviteLoading };
};
